import React, { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/Modal.css';

const Modal = ({ item, onClose }) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    // Handle keyboard navigation for PDF
    const handleKeyDown = (e) => {
      if (item.type === 'pdf') {
        if (e.key === 'ArrowLeft' || e.key === 'Left') {
          e.preventDefault();
          e.stopPropagation();
          if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
          }
        } else if (e.key === 'ArrowRight' || e.key === 'Right') {
          e.preventDefault();
          e.stopPropagation();
          if (!item.totalPages || currentPage < item.totalPages) {
            setCurrentPage(currentPage + 1);
          }
        } else if (e.key === 'Escape') {
          e.preventDefault();
          onClose();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentPage, item, onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePrevPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (item.totalPages && currentPage < item.totalPages) {
      setCurrentPage(currentPage + 1);
    } else if (!item.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        <div className="modal-body">
          {item.type === 'video' ? (
            item.videoFile ? (
              <div className="modal-video-wrapper">
                <video
                  src={item.videoFile}
                  poster={item.thumbnail}
                  controls
                  autoPlay
                  className="modal-video"
                  data-testid="modal-html5-video"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : (
              <div className="modal-video-wrapper">
                <iframe
                  src={item.videoUrl}
                  title={item.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="modal-video"
                ></iframe>
              </div>
            )
          ) : item.type === 'pdf' ? (
            <>
              <div className="modal-pdf-wrapper">
                <iframe
                  key={currentPage}
                  src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(item.pdfUrl)}#page=${currentPage}&zoom=page-fit&pagemode=none&scrollbar=0`}
                  title={item.title}
                  className="modal-pdf"
                  scrolling="no"
                  style={{ overflow: 'hidden' }}
                ></iframe>
              </div>
              <div className="pdf-navigation">
                <button 
                  className="pdf-nav-btn" 
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={24} />
                </button>
                <span className="pdf-page-info">
                  Page {currentPage} {item.totalPages ? `of ${item.totalPages}` : ''}
                </span>
                <button 
                  className="pdf-nav-btn" 
                  onClick={handleNextPage}
                  disabled={item.totalPages && currentPage === item.totalPages}
                >
                  <ChevronRight size={24} />
                </button>
              </div>
            </>
          ) : (
            <img src={item.image} alt={item.title} className="modal-image" />
          )}
          <div className="modal-info">
            <h3 className="modal-title">{item.title}</h3>
            <p className="modal-date">{item.date}</p>
            {item.categoryLabel && (
              <p className="modal-category">{item.categoryLabel}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
